import { Anchor, List, Text, Title } from "@mantine/core";
import { Link } from "react-router-dom";
import LegalPageLayout from "./LegalPageLayout";

export default function TermsOfService() {
  return (
    <LegalPageLayout title="Terms of Service" lastUpdated="August 18, 2026">
      <Text size="sm">
        These Terms of Service ("Terms") govern access to and use of this Admin
        Panel ("the Platform"), an{" "}
        <strong>
          in-house tool built and operated by Thinkcloudly for its own internal
          use only
        </strong>
        . The Platform is used by Thinkcloudly staff to manage students,
        trainers, batches, and related business operations — it is not a product
        or service offered to customers or any external organization. By signing
        in, you agree to these Terms.
      </Text>

      <Title order={4}>1. Authorized Use Only</Title>
      <Text size="sm">
        The Platform is intended solely for use by authorized Thinkcloudly
        employees, contractors, and trainers who have been granted an account.
        It is not available to students, customers, or the general public, and
        must never be accessed by anyone outside Thinkcloudly. Sharing your
        login credentials or granting access to unauthorized individuals is
        strictly prohibited.
      </Text>

      <Title order={4}>2. Account Responsibilities</Title>
      <List size="sm" spacing={4}>
        <List.Item>
          You are responsible for maintaining the confidentiality of your
          username and password.
        </List.Item>
        <List.Item>
          You must notify an administrator immediately of any suspected
          unauthorized use of your account.
        </List.Item>
        <List.Item>
          You are responsible for all activity that occurs under your account.
        </List.Item>
      </List>

      <Title order={4}>3. Acceptable Use</Title>
      <Text size="sm">When using the Platform, you agree not to:</Text>
      <List size="sm" spacing={4}>
        <List.Item>
          Access, modify, or export student, trainer, or financial data outside
          the scope of your role.
        </List.Item>
        <List.Item>
          Attempt to bypass authentication, security controls, or role-based
          access restrictions.
        </List.Item>
        <List.Item>
          Use the Platform for any purpose unrelated to Thinkcloudly's business
          operations.
        </List.Item>
        <List.Item>
          Introduce malicious code or attempt to disrupt the Platform's
          availability or integrity.
        </List.Item>
      </List>

      <Title order={4}>4. Data &amp; Confidentiality</Title>
      <Text size="sm">
        Information accessed through the Platform — including student and
        trainer records, invoices, and internal reports — is confidential and
        proprietary to Thinkcloudly. It must not be copied, disclosed, or used
        outside the scope of your assigned responsibilities. See our{" "}
        <Anchor component={Link} to="/privacy-policy" size="sm">
          Privacy Policy
        </Anchor>{" "}
        for details on how data is collected and protected.
      </Text>

      <Title order={4}>5. Availability</Title>
      <Text size="sm">
        The Platform is provided on an "as is" and "as available" basis. We aim
        to keep it accessible and reliable but do not guarantee uninterrupted or
        error-free operation, and we may modify, suspend, or discontinue
        features at any time.
      </Text>

      <Title order={4}>6. Termination of Access</Title>
      <Text size="sm">
        Access to the Platform may be suspended or revoked at any time, with or
        without notice, including upon end of employment or engagement, or in
        response to a violation of these Terms.
      </Text>

      <Title order={4}>7. Limitation of Liability</Title>
      <Text size="sm">
        Thinkcloudly is not liable for any indirect, incidental, or
        consequential damages arising from use of, or inability to use, the
        Platform.
      </Text>

      <Title order={4}>8. Changes to These Terms</Title>
      <Text size="sm">
        These Terms may be updated periodically. Continued use of the Platform
        after changes are posted constitutes acceptance of the updated Terms.
      </Text>

      <Title order={4}>9. Contact</Title>
      <Text size="sm">
        Questions about these Terms should be directed to your Thinkcloudly
        administrator.
      </Text>
    </LegalPageLayout>
  );
}
